import React, { useEffect, useRef, useState } from "react";
import { CSVLink } from "react-csv";
import PageTitle from "../../../components/partials/PageTitle";
import pdf from "../../../assets/images/img-icons/pdf.png";
import excel from "../../../assets/images/img-icons/excel.png";
import { Link, useNavigate } from "react-router-dom";
import { BeatLoader, BounceLoader } from "react-spinners";
import { MdEdit, MdRemoveRedEye } from "react-icons/md";
import { useDispatch } from "react-redux";
import {
  getAllCovers,
  resetCoverStatus,
} from "../../../redux/slice/cover/coverSlice";
import { useSelector } from "react-redux";
import moment from "moment";
import PaginationLinks from "../../../components/pagination/PaginationLinks";
import { LoaderTwo } from "../../../components/loader/LoaderTwo";

const Cover = () => {
  const CCPdfRef = useRef();

  const [hasCreateCover, setHasCreateCover] = useState(null);
  const [hasViewCover, setHasViewCover] = useState(null);

  const { isLoading, all_covers, isSuccess } = useSelector(
    (state) => state.cover
  );

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const breadcrumb = {
    from: {
      title: "Cover",
      link: "/admin/settings/cover",
    },
    current: {
      title: "Policy Cover",
      link: null,
    },
  };

  const fetchCoversHandler = async (pageNum) => {
    // setPageNumber(pageNum);
    dispatch(getAllCovers(pageNum));
  };

  useEffect(() => {
    dispatch(getAllCovers(1));
  }, [dispatch]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetCoverStatus());
    }
  }, [dispatch, isSuccess]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "cover module"
      )
    ) {
      navigate("/admin/dashboard");
    }

    setHasCreateCover(
      user_permissions?.some((permission) => permission.name === "create cover")
    );
    setHasViewCover(
      user_permissions?.some((permission) => permission.name === "view cover")
    );
  }, [navigate, user_permissions]);

  if (all_covers?.length === 0 && isLoading) {
    return (
      <div className='mt-2'>
        <LoaderTwo />
      </div>
    );
  }

  return (
    <>
      {/* page title */}
      <PageTitle title='Policy Cover' breadcrumb={breadcrumb} />
      {/* end page title */}
      <div className='row card p-1' style={{ margin: "auto 1px" }}>
        <div className='mb-1 pb-1 border border-bottom-1 border-start-0 border-end-0 border-top-0'>
          <div className={`d-flex justify-content-between align-items-center`}>
            <div>
              {hasCreateCover && (
                <Link
                  className='d-flex gap-2 justify-content-center align-items-center rounded-1 btn-primary cursor-p px-3'
                  style={{ height: "30px", padding: "10px 10px" }}
                  to='/admin/settings/cover/add-cover'
                >
                  <span>
                    <i className='mdi mdi-plus fs-4'></i>
                  </span>
                  <span className='text-dark pe-2 text-white'>
                    Add Policy Cover
                  </span>
                </Link>
              )}
            </div>
            <div className='d-flex justify-content-between align-items-center gap-3'>
              <form
                //   onSubmit={handleSearch}
                className='d-flex bg-primary-1 align-items-center '
                style={{ height: "30px", width: "217px" }}
              >
                <input
                  type='search'
                  // value={filterBy}
                  className='border-0'
                  placeholder='Search...'
                  // onChange={(e) => setFilterBy(e.target.value)}
                  style={{ height: "28px", marginLeft: "1px", outline: "none" }}
                />
                <button
                  type='submit'
                  className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                  style={{ height: "28px" }}
                >
                  <i className='uil uil-search text-white fs-4'></i>
                </button>
              </form>
              <div className=' d-flex align-items-center border '>
                <span
                  className='bg-info me-2 text-white'
                  style={{ padding: "3px" }}
                >
                  Export to
                </span>
                <span
                  href='#'
                  id='btnExport'
                  className='me-1'
                  title='Export to Pdf'
                  // onClick={generatePDF}
                >
                  <img src={pdf} alt='export-pdf' style={{ height: "20px" }} />
                </span>
                <CSVLink
                  data={[]}
                  style={{ fontWeight: "bolder" }}
                  filename='Available Users'
                >
                  <span
                    href='#'
                    id='btnExport'
                    className='mr-1'
                    title='Export to Excel'
                  >
                    <img
                      src={excel}
                      alt='export-excel'
                      style={{ height: "20px", marginRight: "5px" }}
                    />
                  </span>
                </CSVLink>
              </div>
            </div>
          </div>
        </div>
        <div className='col-12'>
          <div className='position-relative'>
            <div className='row'>
              <div className='col-sm-12'>
                <div className='table-responsive'>
                  <table
                    className='table table-centered table-striped nowrap w-100 no-footer'
                    ref={CCPdfRef}
                  >
                    <thead>
                      <tr>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "225.8px" }}
                          aria-label='Customer: activate to sort column ascending'
                        >
                          Name
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                        >
                          Policy Category
                        </th>
                        <th
                          className='sorting'
                          tabIndex='0'
                          rowSpan='1'
                          colSpan='1'
                          style={{ width: "167.8px" }}
                          aria-label='Email: activate to sort column ascending'
                        >
                          Date
                        </th>
                        {hasViewCover && (
                          <th
                            className='sorting text-center'
                            tabIndex='0'
                            rowSpan='1'
                            colSpan='1'
                            style={{ width: "95.8px" }}
                            aria-label='Status: activate to sort column ascending'
                          >
                            Action
                          </th>
                        )}
                      </tr>
                    </thead>
                    {all_covers?.all_cover?.data?.length ? (
                      <tbody>
                        {all_covers?.all_cover?.data?.map((item, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                <span>{item.name}</span>
                              </td>
                              <td>
                                {item?.PolicyCategory === "1" &&
                                  "General Policy"}
                                {item?.PolicyCategory === "2" &&
                                  "Savings Policy"}
                                {item?.PolicyCategory === "3" && "Credit Life"}
                              </td>
                              <td className=''>
                                {moment(`${item?.date}`).format("LL")}
                              </td>
                              {hasViewCover && (
                                <td className='text-center'>
                                  <Link
                                    to={`/admin/settings/cover/${item?.id}`}
                                    className='text-left'
                                  >
                                    <MdRemoveRedEye
                                      className='text-primary'
                                      style={{
                                        fontSize: "20px",
                                        textAlign: "start",
                                      }}
                                    />
                                  </Link>
                                </td>
                              )}
                            </tr>
                          );
                        })}
                      </tbody>
                    ) : null}
                  </table>
                </div>
                {all_covers?.all_cover?.data?.length < 1 ? (
                  <h5 className='alert alert-info'>No result found!</h5>
                ) : null}
                <div className='row mt-2'>
                  <div className='col-sm-12 col-md-6'>
                    <div
                      className='dataTables_info table-pages'
                      id='products-datatable_info'
                      role='status'
                      aria-live='polite'
                    >
                      Showing offices {all_covers?.all_cover?.from} to{" "}
                      {all_covers?.all_cover?.to} of{" "}
                      {all_covers?.all_cover?.total}
                    </div>
                  </div>
                  <div className='col-sm-12 col-md-6'>
                    <PaginationLinks
                      paginationData={all_covers?.all_cover}
                      getNextPage={fetchCoversHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* {(isFiltering || isSearching) && (
                  <div
                    className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                    style={{ height: "100%" }}
                  >
                    <div className='mx-auto'>
                      <BounceLoader
                        color='#090b8f'
                        loading={true}
                        // cssOverride={override}
                        size={50}
                        aria-label='Loading Spinner'
                        data-testid='loader'
                        className='ms-3'
                      />
                      <span className='fw-bolder text-primary-1 ms-2'>
                        Please wait...
                      </span>
                    </div>
                  </div>
                )} */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Cover;
